import { createContext } from '@shared/utils/createContext';

export interface DelayShippingContext {
  isDelayShippingEnabled: boolean;
  onOpenConfirmationDialog: () => void;
  loadingDelayOrderFulfillment: boolean;
}

export const [Provider, useDelayShippingContext] = createContext<DelayShippingContext>({ name: 'DelayShippingContext' });
